export default __webpack_public_path__ + "static/media/(1).513627da.jpeg";